// Cấu hình thông báo chuyển sang hệ thống mới.
// Hệ thống cũ ngừng nhận đơn mới sau thời điểm NEW_SYSTEM_CUTOFF.
export const NEW_SYSTEM_CUTOFF = new Date('2026-10-14T08:00:00+07:00');

// Link hệ thống mới. Để trống thì nút "Sang hệ thống mới" sẽ không hiển thị.
export const NEW_SYSTEM_URL = '';
